export default __webpack_public_path__ + "01a4836d8bbfcb7c1412a4274a23563f.png";